module.exports = __webpack_public_path__ + "static/media/Slide35.99765457.JPG";